import React from "react";
import { Link, useNavigate } from "react-router-dom";
import facebook from "../image/social-media/facebook.svg";
import instagram from "../image/social-media/instagram.svg";
import twitter from "../image/social-media/twitter.svg";
import linkedIn from "../image/social-media/linkedin.svg";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <footer className="w-full bg-custom-gradient">
        <div className="p-10 lg:p-20">
          {/* First Row: Logo and Questions */}
          <div className="flex flex-col items-center justify-between mb-8 lg:flex-row">
            <div className="flex items-center mb-4 lg:mb-0">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/01e8c0b767afb3ff75425224b56957481ed1b96e1f3b155705562842b4be13fd?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                alt="Logo Part 1"
                className="shrink-0 aspect-[0.75] w-[33px]"
              />
            </div>
            <div className="flex flex-col items-center lg:items-start">
              <h3 className="text-[1.1rem] font-semibold mb-2">
                Have Questions?
              </h3>
              <button
                type="submit"
                className="px-8 py-2 text-white bg-[#1d6362] rounded-xl max-md:px-4 max-md:w-24 max-md:text-xs"
                onClick={() => navigate("/contact-us")}
              >
                Talk to us
              </button>
            </div>
          </div>

          {/* Horizontal Row */}
          <hr className="my-8 border-t border-gray-300" />

          {/* Second Row: Newsletter, Our Platform, Pricing, Help */}
          <div className="hidden gap-8 mb-8 sm:grid sm:grid-cols-4">
            <div className="flex flex-col items-center lg:items-start">
              <h2 className="text-[#1d6362] font-semibold text-[1.6rem] mb-4">
                Subscribe to our <br className="lg:hidden" /> newsletter
              </h2>
              <div className="flex w-full">
                <input
                  type="email"
                  placeholder="Email address"
                  className="border-b-2 h-[48px] tracking-wide border-[#ccc] bg-transparent w-full max-w-[370px] px-2"
                />
                <button
                  type="submit"
                  className="ml-2 px-4 py-1 text-white bg-[#1d6362] h-[48px] rounded-xl"
                >
                  {">"}
                </button>
              </div>
            </div>
            <div className="flex flex-col items-center lg:items-start">
              <h2 className="text-[1.6rem] font-bold">Our Platform</h2>
              <div className="flex flex-col text-[1rem] mt-3 gap-y-2">
                <a
                  href="https://hirebeen.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Hirebeen
                </a>
                <a
                  href="https://hirebeen.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Techbeen
                </a>
              </div>
            </div>
            <div className="flex flex-col items-center lg:items-start">
              <h2 className="text-[1.6rem] font-bold">Pricing</h2>
              <div className="flex flex-col text-[1rem] mt-3 gap-y-2">
                <h6>
                  <Link to="/pricing">Pricing</Link>
                </h6>
              </div>
            </div>
            <div className="flex flex-col items-center lg:items-start">
              <h2 className="text-[1.6rem] font-bold">Help</h2>
              <div className="flex flex-col text-[1rem] mt-3 gap-y-2">
                <h6>
                  <Link to="/contact-us">Contact</Link>
                </h6>
                <h6>
                  <Link to="/about-us">About</Link>
                </h6>
              </div>
            </div>
          </div>

          {/* Final Row: Terms & Conditions, Privacy Policy, Social Media Icons */}
          <div className="flex flex-col items-center gap-y-4 lg:flex-row lg:justify-between">
            <div className="flex flex-row gap-8 lg:flex-row lg:mb-0">
              <h6>
                <Link to="/termsAndConditions">Terms & Conditions</Link>
              </h6>
              <h6>
                <Link to="/privacy-page">Privacy Policy</Link>
              </h6>
            </div>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/hirebeen/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={facebook} alt="facebook" className="w-6 h-6" />
              </a>
              <a
                href="https://www.instagram.com/hirebeenai/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagram} alt="instagram" className="w-6 h-6" />
              </a>
              <a
                href="https://x.com/hirebeenai/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={twitter} alt="twitter" className="w-6 h-6" />
              </a>
              <a
                href="https://www.linkedin.com/company/hirebeen/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={linkedIn} alt="linkedIn" className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
